// 採用サイト（/careers 以下）はコーポレートサイトとは別のヘッダー・フッターで見せる。
export const CAREERS_BASE = '/careers';

export const isCareersPath = (pathname) =>
  pathname === CAREERS_BASE || pathname.startsWith(`${CAREERS_BASE}/`);

// 募集ごとのページ（/careers/jobs/<募集の id>）。Google の求人検索に載せるため、募集を1つずつ別のページにする
export const CAREERS_JOBS_BASE = `${CAREERS_BASE}/jobs`;
export const careersJobPath = (id) => `${CAREERS_JOBS_BASE}/${id}`;
export const isCareersJobPath = (pathname) => pathname.startsWith(`${CAREERS_JOBS_BASE}/`);

// URLは変わるがページ内の操作（モーダル開閉・タブ切替）なので、スクロール位置をトップへ戻さない遷移。
// /about ↔ /about/:memberId（メンバーモーダル）、/careers ↔ /careers/:section（採用サイトのタブ・セクション）。
// 募集ごとのページは別のページなので、行き来したらトップへ戻す。
export const isInPageTransition = (prev, next) =>
  (prev.startsWith('/about') && next.startsWith('/about')) ||
  (isCareersPath(prev) && isCareersPath(next) && !isCareersJobPath(prev) && !isCareersJobPath(next));

// コミュニティ「LOCKED IN」のLP（/community）も、コーポレートサイトとは別のヘッダー・フッターで見せる。
export const COMMUNITY_BASE = '/community';

export const isCommunityPath = (pathname) =>
  pathname === COMMUNITY_BASE || pathname.startsWith(`${COMMUNITY_BASE}/`);

// 会社概要のうち、/about/:id でディープリンクできるセクションの id（Careers 等から。ビルド後のプリレンダーも使う）
export const ABOUT_SECTION_IDS = ['vision-mission', 'values', 'team', 'company', 'group'];

// 検索広告の着地ページ（/lp/...。2026-11-05 代表指示）。会社のサイトとはトーンを変えた専用のページなので、
// サイトのヘッダー・フッター・装飾（カスタムカーソル・粒子・なめらかなスクロール）を出さない。
// 検索結果には出さない（noindex。サイトマップにも載らない）。
export const LP_BASE = '/lp';
export const LP_PATHS = Object.freeze({
  enablement: `${LP_BASE}/enablement`,
  orderEntry: `${LP_BASE}/order-entry`,
});

export const isLpPath = (pathname) => pathname === LP_BASE || pathname.startsWith(`${LP_BASE}/`);
